import { apiRequest } from './api';

export const qualityManagementApi = {
  getHotels: () => apiRequest('/quality-management/hotels/'),
  createHotel: (payload) => apiRequest('/quality-management/hotels/', 'POST', payload),
  updateHotel: (id, payload) => apiRequest(`/quality-management/hotels/${id}/`, 'PUT', payload),
  deleteHotel: (id) => apiRequest(`/quality-management/hotels/${id}/`, 'DELETE'),

  getDfDefinitions: () => apiRequest('/quality-management/df-definitions/'),
  getNextDfNumber: (departmentId = null, hotelId = null) => {
    const params = new URLSearchParams();
    if (departmentId) params.append('department_id', departmentId);
    if (hotelId) params.append('hotel_id', hotelId);
    const query = params.toString();
    return apiRequest(`/quality-management/df-definitions/next-number/${query ? `?${query}` : ''}`);
  },
  createDfDefinition: (payload) => apiRequest('/quality-management/df-definitions/', 'POST', payload),
  updateDfDefinition: (id, payload) => apiRequest(`/quality-management/df-definitions/${id}/`, 'PUT', payload),
  deleteDfDefinition: (id) => apiRequest(`/quality-management/df-definitions/${id}/`, 'DELETE'),

  getDepartments: (hotelId = null) => apiRequest(`/quality-management/departments/${hotelId ? `?hotel_id=${hotelId}` : ''}`),
  getAllDepartments: () => apiRequest('/quality-management/departments/?all=1'),
  createDepartment: (payload) => apiRequest('/quality-management/departments/', 'POST', payload),
  updateDepartment: (id, payload) => apiRequest(`/quality-management/departments/${id}/`, 'PUT', payload),
  deleteDepartment: (id) => apiRequest(`/quality-management/departments/${id}/`, 'DELETE'),
  getQmUsers: (hotelId = null, departmentId = null) => {
    if (departmentId) return apiRequest(`/quality-management/users/?department_id=${departmentId}`);
    if (hotelId) return apiRequest(`/quality-management/users/?hotel_id=${hotelId}`);
    return apiRequest('/quality-management/users/');
  },
  getAllQmUsers: () => apiRequest('/quality-management/users/?all=1'),
  createQmUser: (payload) => apiRequest('/quality-management/users/', 'POST', payload),
  updateQmUser: (id, payload) => apiRequest(`/quality-management/users/${id}/`, 'PUT', payload),
  deleteQmUser: (id) => apiRequest(`/quality-management/users/${id}/`, 'DELETE'),

  getNonconformitySummaries: () => apiRequest('/quality-management/nonconformity-summaries/'),
  createNonconformitySummary: (payload) => apiRequest('/quality-management/nonconformity-summaries/', 'POST', payload),
  updateNonconformitySummary: (id, payload) => apiRequest(`/quality-management/nonconformity-summaries/${id}/`, 'PUT', payload),
  deleteNonconformitySummary: (id) => apiRequest(`/quality-management/nonconformity-summaries/${id}/`, 'DELETE'),

  getNonconformitySources: () => apiRequest('/quality-management/nonconformity-sources/'),
  createNonconformitySource: (payload) => apiRequest('/quality-management/nonconformity-sources/', 'POST', payload),
  updateNonconformitySource: (id, payload) => apiRequest(`/quality-management/nonconformity-sources/${id}/`, 'PUT', payload),
  deleteNonconformitySource: (id) => apiRequest(`/quality-management/nonconformity-sources/${id}/`, 'DELETE'),

  getRootCauseSummaries: () => apiRequest('/quality-management/root-cause-summaries/'),
  createRootCauseSummary: (payload) => apiRequest('/quality-management/root-cause-summaries/', 'POST', payload),
  updateRootCauseSummary: (id, payload) => apiRequest(`/quality-management/root-cause-summaries/${id}/`, 'PUT', payload),
  deleteRootCauseSummary: (id) => apiRequest(`/quality-management/root-cause-summaries/${id}/`, 'DELETE'),

  getForms: (params = {}) => {
    const q = new URLSearchParams();
    if (params.workflow_stage) q.append('workflow_stage', params.workflow_stage);
    const qs = q.toString();
    return apiRequest(`/quality-management/forms/${qs ? `?${qs}` : ''}`);
  },
  getForm: (id) => apiRequest(`/quality-management/forms/${id}/`),
  createForm: (payload) => apiRequest('/quality-management/forms/', 'POST', payload),
  updateForm: (id, payload) => apiRequest(`/quality-management/forms/${id}/`, 'PUT', payload),
  deleteForm: (id) => apiRequest(`/quality-management/forms/${id}/`, 'DELETE'),
  submitInitiation: (id) =>
    apiRequest(`/quality-management/forms/${id}/submit-initiation/`, 'POST', {}),
  submitAction: (id) =>
    apiRequest(`/quality-management/forms/${id}/submit-action/`, 'POST', {}),
  approveForm: (id, approved) =>
    apiRequest(`/quality-management/forms/${id}/approve/`, 'POST', { approved }),
  sendFormToClosing: (id, payload = {}) =>
    apiRequest(`/quality-management/forms/${id}/send-to-closing/`, 'POST', payload),
  rejectAndCloneForm: (id, payload = {}) =>
    apiRequest(`/quality-management/forms/${id}/reject-and-clone/`, 'POST', payload),
  closeForm: (id, closed) =>
    apiRequest(`/quality-management/forms/${id}/close/`, 'POST', { closed }),

  getDofAccessUsers: () => apiRequest('/quality-management/dof-access/'),
  updateDofAccessUsers: (userIds) =>
    apiRequest('/quality-management/dof-access/', {
      method: 'PUT',
      body: JSON.stringify({ user_ids: userIds }),
    }),
};
